import { render, staticRenderFns } from "./bindingcreat.vue?vue&type=template&id=23aaffe2&scoped=true&"
import script from "./bindingcreat.vue?vue&type=script&lang=ts&"
export * from "./bindingcreat.vue?vue&type=script&lang=ts&"
import style0 from "./bindingcreat.vue?vue&type=style&index=0&id=23aaffe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aaffe2",
  null
  
)

export default component.exports